import { Components, Theme } from '@mui/material/styles';

const breadcrumbsTheme: Components<Theme>['MuiBreadcrumbs'] = {
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.palette.offGray,
            fontSize: '16px'
        }),
    },
};

export default breadcrumbsTheme;
